import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactObserver from 'Components/ReactObserver/ReactObserver';
import { NAVBAR_ITEMS, HEADER_OFFSET } from 'Constants/items';
import { isMobile } from 'Helpers/devices';

const ReactObserverWrapper = ({ children, navBarItemId, impression, setSelectedTabId, recordItemImpressions, onChange, triggerOnce }) => {
    const [isRendered, setIsRendered] = useState();

    return (<ReactObserver rootMargin={ `-${HEADER_OFFSET}px 0px 0px` } onChange={ onChange } triggerOnce={ triggerOnce }>
        {({ inView, ref, entry }) => {
            if (!isRendered && !inView) {
                return <div ref={ ref } />;
            }
            if (entry && inView) {
                if (!isMobile) {
                    setSelectedTabId(navBarItemId);
                }
                recordItemImpressions(impression);
            }
            else if (entry && !inView && !isMobile) {
                setSelectedTabId(navBarItemId, true);
            }
            if (!isRendered && inView) {
                setIsRendered(true);
            }

            return (<div ref={ ref }>
                {children}
            </div>);
        }}
    </ReactObserver>);
};

ReactObserverWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    impression: PropTypes.string.isRequired,
    navBarItemId: PropTypes.number,
    setSelectedTabId: PropTypes.func,
    recordItemImpressions: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    triggerOnce: PropTypes.bool
};

ReactObserverWrapper.defaultProps = {
    setSelectedTabId: () => {},
    onChange: () => {},
    navBarItemId: NAVBAR_ITEMS.OVERVIEW,
    triggerOnce: false
};

export default ReactObserverWrapper;
